@if (error > 0) {
  <div class="container-fluid vert-offset-top-4 vert-offset-bottom-4">
    <div class="row">
      <div class="col-md-6 col-md-offset-3 text text-danger" [style.text-align]="'center'">
        <i class="app-icon pi pi-exclamation-triangle"></i>
        @if (401) {
          <span>{{'Invalid Token Used' | translate}}</span>
        }
      </div>
    </div>
    <div class="row vert-offset-top-1">
      <div class="col-md-6 col-md-offset-3" [style.text-align]="'center'">
        <i class="app-icon pi pi-spin pi-spinner"></i>
        <span>{{ 'Please wait while we redirect you to home page.' | translate }}</span>
      </div>
    </div>
  </div>
}